import { jsx } from 'react/jsx-runtime';
import { useState, useEffect } from 'react';
import classNames from 'classnames';
import { useTermsOfServiceContext } from '../Provider/index.es.js';
import { sanitizeHtml } from './utils.es.js';

const TermsOfServiceContent = ({ html, className, sanitizeOptions, ...rest })=>{
    const [sanitized, setSanitized] = useState('');
    const [, { setIsSanitized }] = useTermsOfServiceContext();
    useEffect(()=>{
        void (()=>{
            try {
                const sanitizedHtml = sanitizeHtml(html, sanitizeOptions);
                setSanitized(sanitizedHtml);
                setIsSanitized?.();
            } catch (error) {
                console.warn('[TermsOfService] Failed to sanitize html: ', error);
            }
        })();
    }, [
        html,
        sanitizeOptions,
        setIsSanitized
    ]);
    return jsx("div", {
        dangerouslySetInnerHTML: {
            __html: sanitized
        },
        className: classNames('terms-of-service', className),
        ...rest
    });
};

export { TermsOfServiceContent };
//# sourceMappingURL=TermsOfServiceContent.es.js.map
